import { render, staticRenderFns } from "./ClientModal.vue?vue&type=template&id=2bf24aff&scoped=true"
import script from "./ClientModal.vue?vue&type=script&lang=js"
export * from "./ClientModal.vue?vue&type=script&lang=js"
import style0 from "./ClientModal.vue?vue&type=style&index=0&id=2bf24aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf24aff",
  null
  
)

export default component.exports